export const P0003600CourantNominalEnum = [
  { ref: 10, label: '1.0 A' },
  { ref: 11, label: '1.1 A' },
  { ref: 12, label: '1.2 A' },
  { ref: 13, label: '1.3 A' },
  { ref: 14, label: '1.4 A' },
  { ref: 15, label: '1.5 A' },
  { ref: 16, label: '1.6 A' },
  { ref: 17, label: '1.7 A' },
  { ref: 18, label: '1.8 A' },
  { ref: 19, label: '1.9 A' },
  { ref: 20, label: '2.0 A' },
  { ref: 21, label: '2.1 A' },
  { ref: 22, label: '2.2 A' },
  { ref: 23, label: '2.3 A' },
  { ref: 24, label: '2.4 A' },
  { ref: 25, label: '2.5 A' },
  { ref: 26, label: '2.6 A' },
  { ref: 27, label: '2.7 A' },
  { ref: 28, label: '2.8 A' },
  { ref: 29, label: '2.9 A' },
  { ref: 30, label: '3.0 A' },
  { ref: 31, label: '3.1 A' },
  { ref: 32, label: '3.2 A' },
  { ref: 33, label: '3.3 A' },
  { ref: 34, label: '3.4 A' },
  { ref: 35, label: '3.5 A' },
  { ref: 36, label: '3.6 A' },
  { ref: 37, label: '3.7 A' },
  { ref: 38, label: '3.8 A' },
  { ref: 39, label: '3.9 A' },
  { ref: 40, label: '4.0 A' },
  { ref: 41, label: '4.1 A' },
  { ref: 42, label: '4.2 A' },
  { ref: 43, label: '4.3 A' },
  { ref: 44, label: '4.4 A' },
  { ref: 45, label: '4.5 A' },
  { ref: 46, label: '4.6 A' },
  { ref: 47, label: '4.7 A' },
  { ref: 48, label: '4.8 A' },
  { ref: 49, label: '4.9 A' },
  { ref: 50, label: '5.0 A' },
  { ref: 51, label: '5.1 A' },
  { ref: 52, label: '5.2 A' },
  { ref: 53, label: '5.3 A' },
  { ref: 54, label: '5.4 A' },
  { ref: 55, label: '5.5 A' },
  { ref: 56, label: '5.6 A' },
  { ref: 57, label: '5.7 A' },
  { ref: 58, label: '5.8 A' },
  { ref: 59, label: '5.9 A' },
  { ref: 60, label: '6.0 A' },
  { ref: 61, label: '6.1 A' },
  { ref: 62, label: '6.2 A' },
  { ref: 63, label: '6.3 A' },
  { ref: 64, label: '6.4 A' },
  { ref: 65, label: '6.5 A' },
  { ref: 66, label: '6.6 A' },
  { ref: 67, label: '6.7 A' },
  { ref: 68, label: '6.8 A' },
  { ref: 69, label: '6.9 A' },
  { ref: 70, label: '7.0 A' },
  { ref: 71, label: '7.1 A' },
  { ref: 72, label: '7.2 A' },
  { ref: 73, label: '7.3 A' },
  { ref: 74, label: '7.4 A' },
  { ref: 75, label: '7.5 A' },
  { ref: 76, label: '7.6 A' },
  { ref: 77, label: '7.7 A' },
  { ref: 78, label: '7.8 A' },
  { ref: 79, label: '7.9 A' },
  { ref: 80, label: '8.0 A' },
  { ref: 81, label: '8.1 A' },
  { ref: 82, label: '8.2 A' },
  { ref: 83, label: '8.3 A' },
  { ref: 84, label: '8.4 A' },
  { ref: 85, label: '8.5 A' },
  { ref: 86, label: '8.6 A' },
  { ref: 87, label: '8.7 A' },
  { ref: 88, label: '8.8 A' },
  { ref: 89, label: '8.9 A' },
  { ref: 90, label: '9.0 A' },
  { ref: 91, label: '9.1 A' },
  { ref: 92, label: '9.2 A' },
  { ref: 93, label: '9.3 A' },
  { ref: 94, label: '9.4 A' },
  { ref: 95, label: '9.5 A' },
  { ref: 96, label: '9.6 A' },
  { ref: 97, label: '9.7 A' },
  { ref: 98, label: '9.8 A' },
  { ref: 99, label: '9.9 A' },
  { ref: 100, label: '10.0 A' },
];
